import { StyleSheet, Dimensions, Platform } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { PlatformUtils } from '@vfgroup-oneplatform/foundation/Utils';

const isIPhoneWithNotch = PlatformUtils.isIPhoneDeviceWithNotch();

const screenWidth = Dimensions.get('window').width;
const screenHeight = Dimensions.get('window').height;

export default StyleSheet.create({
  controlBarContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 100,
    paddingRight: Platform.OS === 'android' ? 50 : 30,
    paddingLeft: 30,
  },
  fullScreenButtonContainer: {
    height: 90,
    paddingRight: Platform.OS === 'android' ? 50 : 30,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  controlsContainer: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'space-between',
  },
  controlsContainerLandscape: {
    paddingRight: isIPhoneWithNotch ? 44 : 0,
  },
  container: {
    flex: 1,
  },
  timeContainer: {
    alignItems: 'center',
    minWidth: 70,
  },
  videoBackground: {
    backgroundColor: Colors.dark_grey,
    flex: 1,
  },
  fullScreen: {
    ...StyleSheet.absoluteFillObject,
  },
  videoStyle: {
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    flex: 1,
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    height: '100%',
  },
  videoStyleView: {
    flex: 1,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
  },
  textColor: {
    color: Colors.white,
  },
  videoRotated: {
    alignSelf: 'center',
    width: screenHeight,
    height: screenWidth,
    flex: 0,
    transform: [
      {
        rotate: '90deg',
      },
    ],
  },
  posterImageStyle: {
    ...StyleSheet.absoluteFillObject,
    flex: 1,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    resizeMode: 'cover',
  },
  posterImageView: {
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '100%',
  },
});
